<template>
  <div
    id="newPartListModal"
    class="modal-mini modal"
    role="dialog"
    aria-labelledby="newPartListModelLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3
            id="newPartListModelLabel"
            class="modal-title"
          >
            {{ getContentItem('newPartList') }}
          </h3>
          <button type="button" class="close" data-dismiss="modal">
            ×
          </button>
        </div>
        <div class="modal-body">
          <p>{{ getContentItem('partListName') }}:</p>
          <div class="control-group">
            <input
              v-model="partListName"
              type="text"
              tabindex="1"
              class="partListName"
            >
          </div>
        </div>
        <div class="modal-footer">
          <a
            id="btnSaveNewPartList"
            class="btn btn-primary"
            type="button"
            @click="CreatePartList"
          >{{ getContentItem('save') }}</a>
          <a class="btn" data-dismiss="modal">{{ getContentItem('close') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { PartListService } from "@/services/PartListService";
  import { ErrorLogService } from "@/services/ErrorLogService";
  import { request } from "http";

  export default {
    data: () => ({
      partListName: "",
    }),
    computed: {
      ...mapGetters(["getContentItem", "user"]),
    },
    methods: {
      CreatePartList: function() {
        const request = {
          accountId: this.user.PrimaryAccountId,
          userId: this.user.UserId,
          partListName: this.partListName,
        };
        PartListService.CreateNewPartList(request)
          .then((result) => {
            top.location = `/orders/quickorders?partlistid=${result.Id}`;
          })
          .catch((err) => {
            ErrorLogService.LogException(err);
          });
      },
    },
  };
</script>
